// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWritesSuiCatalogueItem
 */
export interface LongWritesSuiCatalogueItem {
  /**
   *
   * @type {string}
   * @memberof LongWritesSuiCatalogueItem
   */
  activityId: string
  /**
   *
   * @type {string}
   * @memberof LongWritesSuiCatalogueItem
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWritesSuiCatalogueItem
   */
  description?: string | null
}

/**
 * Check if a given object implements the LongWritesSuiCatalogueItem interface.
 */
export function instanceOfLongWritesSuiCatalogueItem(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'activityId' in value

  return isInstance
}

export function LongWritesSuiCatalogueItemFromJSON(
  json: any,
): LongWritesSuiCatalogueItem {
  return LongWritesSuiCatalogueItemFromJSONTyped(json, false)
}

export function LongWritesSuiCatalogueItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWritesSuiCatalogueItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityId: json['activity_id'],
    title: !exists(json, 'title') ? undefined : json['title'],
    description: !exists(json, 'description') ? undefined : json['description'],
  }
}

export function LongWritesSuiCatalogueItemToJSON(
  value?: LongWritesSuiCatalogueItem | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activity_id: value.activityId,
    title: value.title,
    description: value.description,
  }
}
